import { Modal } from "antd";
import useQueueStore from "../../stores/queue-store";
import { SlotSelectionContent } from "../../molecules/cards/queue/select-slot";
import { ModalHeader } from "ui";

const SelectSlotModal = () => {
  const selectedAppointment = useQueueStore(
    (state) => state.selectedAppointment
  );
  const setSelectedAppointment = useQueueStore(
    (state) => state.setSelectedAppointment
  );
  const showSelectSlotModal = useQueueStore(
    (state) => state.showSelectSlotModal
  );
  const selectSlotAptChannel = useQueueStore(
    (state) => state.selectSlotAptChannel
  );
  const selectSlotBookType = useQueueStore((state) => state.selectSlotBookType);
  const setSelectSlotInfo = useQueueStore((state) => state.setSelectSlotInfo);

  const handleClose = () => {
    setSelectedAppointment(undefined);
    setSelectSlotInfo({
      aptChannel: undefined,
      bookType: undefined,
      showModal: false,
    });
  };

  if (!showSelectSlotModal || !selectedAppointment) {
    return null;
  }

  return (
    <Modal
      style={{
        padding: 0,
        borderRadius: "0.5rem",
      }}
      bodyStyle={{ padding: 0 }}
      footer={null}
      closable={false}
      open
      className="dr-min-h-520 overflow-y-auto dr-h-520 dr-max-w-408 dr-w-408 dr-bg-darwin-touch-neutral-0 BodyBody2Bold dr-rounded-16  flex dr-flex-col dr-justify-between dr-relative"
      onCancel={handleClose}
      destroyOnClose={true}
    >
      <ModalHeader
        onClose={handleClose}
        title={
          selectSlotBookType === "RESCHEDULE"
            ? "Reschedule Appointment"
            : "Schedule Appointment"
        }
      />
      <SlotSelectionContent
        aptData={selectedAppointment}
        aptChannel={selectSlotAptChannel}
        bookType={selectSlotBookType}
        onSubmitClick={handleClose}
      />
    </Modal>
  );
};

export default SelectSlotModal;
